import { render, staticRenderFns } from "./listSection.vue?vue&type=template&id=e2c0a8d0&"
import script from "./listSection.vue?vue&type=script&lang=js&"
export * from "./listSection.vue?vue&type=script&lang=js&"
import style0 from "./listSection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports